
import Vue from 'vue';
import IconButton from '@/components/IconButton.vue';

export default Vue.extend({
  components: {
    IconButton,
  },
  props: {
    value: { type: String, required: false },
    counter: { type: Boolean, default: false },
    label: { type: String, required: false },
  },
  data() {
    return {
      edit: false,
      editValue: '',
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(value: string) {
        this.editValue = value || '';
        this.edit = this.editValue === '';
      },
    },
  },
  methods: {
    save() {
      this.edit = false;
      this.$emit('input', this.editValue.trim());
    },
    startEdit() {
      this.edit = !this.edit;
    },
    wordCount(text: string): number {
      // simple word counter function that counts the number of words in a string, excluding spaces and punctuation
      // example: "Hello, world!" has 2 words
      const words = text.replace(/[^\w\s]|_/g, '')
        .replace(/\s+/g, ' ')
        .split(' ').length;
      return words;
    },
    editing(edit: boolean) {
      this.edit = edit;
    },
  },

});
